export enum SocialMediaMetricsFilterType {
  Last7Days = 1,
  LastMonth = 2,
  Last3Months = 3,
  LastYear = 4
}